import styles from './styles.module.scss'

export const EmptyStateStatistic = ({
  description = 'Contacts have not received the message yet',
}: {
  description?: string
}) => {
  return <div className={styles.wrapStatistics}>{description}</div>
}
